const w = (r, e) => ({
  ...r,
  ...e
}), S = (r) => (r == null ? void 0 : r.constructor) === Object, y = async (r, e) => {
  const {
    result: a = "json"
  } = e, h = new URL(r);
  if (e != null && e.parameter) {
    const f = e.parameter;
    h.search = new URLSearchParams(
      Object.keys(f).filter(
        (b) => f[b] !== void 0 && f[b] !== "undefined"
      ).reduce((b, m) => ({
        ...b,
        [m]: f[m]
      }), {})
    ).toString();
  }
  let d = w({
    Accept: "application/json"
  }, e.headers);
  e.body && (Array.isArray(e.body) || S(e.body)) && (d = w({
    "Content-Type": "application/json"
  }, d), e.body = JSON.stringify(e.body));
  const c = await window.fetch(h, {
    body: e == null ? void 0 : e.body,
    cache: e == null ? void 0 : e.cache,
    headers: d,
    method: e == null ? void 0 : e.method,
    signal: e == null ? void 0 : e.signal
  }), l = await E(a, c);
  if (!c.ok)
    throw l;
  return l;
};
async function E(r, e) {
  return r === "text" ? await e.text() : r === "blob" ? await e.blob() : await e.json();
}
function T(r, e) {
  let a = {};
  return e.method === "GET" && e.body && (a = e.body, e.body = void 0), y(r, {
    body: e.body,
    headers: e.headers,
    method: e.method,
    parameter: a,
    result: e.result,
    signal: e.signal
  });
}
function k(r, e) {
  var d, c;
  const a = new FormData();
  a.append("entity", e.body.entity), a.append("namespace", e.body.namespace), Array.isArray(e.body.files) && e.body.files.forEach((l) => {
    a.append("files[]", l);
  }), Array.isArray(e.body.categories) && e.body.categories.forEach((l) => {
    a.append("categories[]", JSON.stringify(l));
  });
  const h = w({
    MantumKey: (d = e == null ? void 0 : e.security) == null ? void 0 : d.key,
    MantumSecret: (c = e == null ? void 0 : e.security) == null ? void 0 : c.secret
  }, e.headers);
  return y(r, {
    body: a,
    headers: h,
    method: e.method,
    result: e == null ? void 0 : e.result
  });
}
function O(r, e) {
  return y(r, {
    cache: e == null ? void 0 : e.cache,
    headers: e == null ? void 0 : e.headers,
    method: "GET",
    parameter: e == null ? void 0 : e.parameter,
    result: e == null ? void 0 : e.result,
    signal: e == null ? void 0 : e.signal
  });
}
let U = (r = 21) => crypto.getRandomValues(new Uint8Array(r)).reduce((e, a) => (a &= 63, a < 36 ? e += a.toString(36) : a < 62 ? e += (a - 26).toString(36).toUpperCase() : a > 62 ? e += "-" : e += "_", e), "");
const A = () => U();
function x(r) {
  const e = A(), a = new AbortController(), h = a.signal, d = {}, c = {}, l = () => {
    e in d && delete d[e];
  }, f = (u) => {
    a.abort(), u in c && delete c[u];
  }, b = (u) => {
    for (const [, t] of Object.entries(c))
      t(u);
  };
  return {
    subscribe: (u) => {
      const t = A();
      return c[t] = u, () => f(t);
    },
    call: (u) => {
      if (Object.keys(c).length === 0)
        return;
      (() => {
        const j = O(r, {
          parameter: u,
          signal: h
        });
        j.then((g) => {
          b(g), l();
        }), j.catch((g) => {
          b(g), l();
        });
      })();
    }
  };
}
function P(r, e) {
  return y(r, {
    body: e == null ? void 0 : e.body,
    headers: e == null ? void 0 : e.headers,
    method: "POST",
    result: e == null ? void 0 : e.result
  });
}
function R(r, e) {
  return y(r, {
    body: e == null ? void 0 : e.body,
    headers: e == null ? void 0 : e.headers,
    method: "PUT",
    result: e == null ? void 0 : e.result
  });
}
function C(r, e) {
  return y(r, {
    headers: e == null ? void 0 : e.headers,
    method: "DELETE",
    result: e == null ? void 0 : e.result
  });
}
const G = {
  delete: C,
  fetch: T,
  file: k,
  get: O,
  observable: x,
  post: P,
  put: R
};
export {
  G as default
};
//# sourceMappingURL=kanela-request.es.js.map
